// extracted by mini-css-extract-plugin
export var container = "banner-module--container--d+adl";
export var heading = "banner-module--heading--MwEXa";
export var headingText = "banner-module--headingText--L+biF";
export var subtitle = "banner-module--subtitle--Emrmi";
export var subheading = "banner-module--subheading--E-jy0";
export var subheadingText = "banner-module--subheadingText--RJZsz";
export var article = "banner-module--article--Nt15c";
export var content = "banner-module--content--vKUZi";
export var role = "banner-module--role--FfcYs";
export var first = "banner-module--first--6PY5t";
export var second = "banner-module--second--OEhyT";
export var divider = "banner-module--divider--Drr4P";